import * as React from 'react';
import { clsx } from 'clsx';
import IconFontAwesome from "../../js/components/iconFontAwesome.tsx";

type Props = React.ComponentPropsWithoutRef<"span"> & {
	className?: string,
	iconClassName?: string
}

function DeleteButton({className = '', iconClassName = '', ...otherProps}: Props) {
	return (<>
		<span className={clsx(className, "cursor-pointer leading-none")} {...otherProps}>
			<IconFontAwesome className={clsx(iconClassName, "icon-times text-2xl hover:text-rose-600")} title="X"/>
		</span>
	</>);
}

export default DeleteButton;
